import {STATISTICS} from '../constants/statistics';

// 3.75 + 3.75 + 3.5 + 3.75 + 3.75 = 18.5
export const balancedScores = () => {
  const scores = uniformScores(0);
  updateStatScore(scores, 'Speed, Ground', 3.75);
  updateStatScore(scores, 'Speed, Water', 3.75);
  updateStatScore(scores, 'Speed, Air', 4.5);
  updateStatScore(scores, 'Speed, Anti-Gravity', 4.25);
  updateStatScore(scores, 'Acceleration', 3.75);
  updateStatScore(scores, 'Weight', 3.5);
  updateStatScore(scores, 'Handling, Ground', 3.75);
  updateStatScore(scores, 'Handling, Water', 3.5);
  updateStatScore(scores, 'Handling, Air', 3.5);
  updateStatScore(scores, 'Handling, Anti-Gravity', 3.5);
  updateStatScore(scores, 'Traction', 3.75);
  updateStatScore(scores, 'Mini-Turbo', 4);
  updateStatScore(scores, 'Invincibility', 4);
  return scores;
};

// 3 + 4.75 + 2 + 4.5 + 3.5 = 17.75
export const beginnerScores = () => {
  const scores = uniformScores(0);
  updateStatScore(scores, 'Speed, Ground', 3);
  updateStatScore(scores, 'Speed, Water', 3.5);
  updateStatScore(scores, 'Speed, Air', 3.25);
  updateStatScore(scores, 'Speed, Anti-Gravity', 2.75);
  updateStatScore(scores, 'Acceleration', 4.75);
  updateStatScore(scores, 'Weight', 2);
  updateStatScore(scores, 'Handling, Ground', 4.5);
  updateStatScore(scores, 'Handling, Water', 4);
  updateStatScore(scores, 'Handling, Air', 3.5);
  updateStatScore(scores, 'Handling, Anti-Gravity', 4.5);
  updateStatScore(scores, 'Traction', 3.5);
  updateStatScore(scores, 'Mini-Turbo', 4.75);
  updateStatScore(scores, 'Invincibility', 3.25);
  return scores;
};

// 2.25 + 5.25 + 2 + 4.5 + 3.5 = 17.5
export const boostFocusedScores = () => {
  const scores = uniformScores(0);
  updateStatScore(scores, 'Speed, Ground', 2.25);
  updateStatScore(scores, 'Speed, Water', 3.25);
  updateStatScore(scores, 'Speed, Air', 3.5);
  updateStatScore(scores, 'Speed, Anti-Gravity', 3);
  updateStatScore(scores, 'Acceleration', 5.25);
  updateStatScore(scores, 'Weight', 2);
  updateStatScore(scores, 'Handling, Ground', 4.5);
  updateStatScore(scores, 'Handling, Water', 4.25);
  updateStatScore(scores, 'Handling, Air', 4.5);
  updateStatScore(scores, 'Handling, Anti-Gravity', 4.25);
  updateStatScore(scores, 'Traction', 3.5);
  updateStatScore(scores, 'Mini-Turbo', 5.5);
  updateStatScore(scores, 'Invincibility', 1);
  return scores;
};

// 2.75 + 2.75 + 2.75 + 5 + 4.25 = 17.5
export const handicapScores = () => {
  const scores = uniformScores(0);
  updateStatScore(scores, 'Speed, Ground', 2.75);
  updateStatScore(scores, 'Speed, Water', 2.75);
  updateStatScore(scores, 'Speed, Air', 2.5);
  updateStatScore(scores, 'Speed, Anti-Gravity', 2.25);
  updateStatScore(scores, 'Acceleration', 2.75);
  updateStatScore(scores, 'Weight', 2.75);
  updateStatScore(scores, 'Handling, Ground', 5);
  updateStatScore(scores, 'Handling, Water', 5);
  updateStatScore(scores, 'Handling, Air', 4.5);
  updateStatScore(scores, 'Handling, Anti-Gravity', 4.25);
  updateStatScore(scores, 'Traction', 4.25);
  updateStatScore(scores, 'Mini-Turbo', 4.25);
  updateStatScore(scores, 'Invincibility', 4.75);
  return scores;
};

// 5.25 + 2 + 4 + 3 + 2 = 16.25
export const speedFocusedScores = () => {
  const scores = uniformScores(0);
  updateStatScore(scores, 'Speed, Ground', 5.25);
  updateStatScore(scores, 'Speed, Water', 4.75);
  updateStatScore(scores, 'Speed, Air', 5);
  updateStatScore(scores, 'Speed, Anti-Gravity', 5);
  updateStatScore(scores, 'Acceleration', 2);
  updateStatScore(scores, 'Weight', 4);
  updateStatScore(scores, 'Handling, Ground', 3);
  updateStatScore(scores, 'Handling, Water', 2.75);
  updateStatScore(scores, 'Handling, Air', 3);
  updateStatScore(scores, 'Handling, Anti-Gravity', 2.5);
  updateStatScore(scores, 'Traction', 2);
  updateStatScore(scores, 'Mini-Turbo', 2.75);
  updateStatScore(scores, 'Invincibility', 4.75);
  return scores;
};

// 3.5 + 3.5 + 3 + 3.75 + 5 = 18.75
export const tractionFocusedScores = () => {
  const scores = uniformScores(0);
  updateStatScore(scores, 'Speed, Ground', 3.5);
  updateStatScore(scores, 'Speed, Water', 4.25);
  updateStatScore(scores, 'Speed, Air', 3.25);
  updateStatScore(scores, 'Speed, Anti-Gravity', 3.5);
  updateStatScore(scores, 'Acceleration', 3.5);
  updateStatScore(scores, 'Weight', 3);
  updateStatScore(scores, 'Handling, Ground', 3.75);
  updateStatScore(scores, 'Handling, Water', 3.5);
  updateStatScore(scores, 'Handling, Air', 4);
  updateStatScore(scores, 'Handling, Anti-Gravity', 3.75);
  updateStatScore(scores, 'Traction', 5);
  updateStatScore(scores, 'Mini-Turbo', 4.25);
  updateStatScore(scores, 'Invincibility', 4);
  return scores;
};

export const uniformScores = (score) => {
  return STATISTICS.map((stat) => ({stat: stat, score: score}));
};

const updateStatScore = (statScores, statName, score) => {
  const statScore = statScores.find((ss) => ss.stat.name === statName);
  statScore.score = score;
};
